<script>

export default {
  name: "DirtyFieldsMixIn",
  computed: {},
  data: () => ({
    unSavedChanges: false,
    dirtyItems: []
  }),
  methods: {
    findDirtyItem(item) {
      return this.dirtyItems.find(dirtyItem => item.id === dirtyItem.id)
    },
    addDirtyRow(items, field, type=null) {
      Object.values(items).forEach(item => this.addDirty(item, field, type))
    },
    addDirty(item, field, optionalKey = null) {
      let dirtyItem = this.findDirtyItem(item)
      if (dirtyItem) {
        if (!(dirtyItem.fields.includes(field))) {
          dirtyItem.fields.push(field)
        }
      } else {
        dirtyItem = {id: item.id, fields: [field], type: optionalKey}
        this.dirtyItems.push(dirtyItem)
      }
      this.unSavedChanges = true
    },
    getDirtyClass(item, field) {
      let dirtyItem = this.findDirtyItem(item)
      return dirtyItem && dirtyItem.fields.includes(field) ? 'border-bottom-orange' : 'border-bottom-blank'
    },
    setUnsavedChanges() {
      this.unSavedChanges = true
    }
  },

}
</script>

<style scoped>

</style>